// ESTADÍSTICAS — la pantalla nueva.
//
// No es una reescritura de `src/Pages/Stats/`: esa pantalla pasa a ser la
// biblioteca de componentes de ésta. Lo que cambia es la ESTRUCTURA.
//
//   ┌─ el estado del dato, siempre a la vista ──────────────────────┐
//
//   ┌ Cómo va │ Ingresos │ Tickets │ Mes a mes │ Ocupación │ Preguntar ┐
//
// La primera pestaña contesta —cómo va hoy, qué hay que revisar, cómo termina
// el mes— y es la activa al entrar, así que quien abre diez segundos se lleva
// la respuesta sin buscar nada. Las otras cinco muestran de dónde sale, y ahí
// separar por tema ordena en vez de esconder, porque quien llega ya sabe qué
// está buscando.
//
// Las pestañas actuales están ordenadas por TIPO DE DATO —Resumen, Ingresos,
// Tickets, Mensual—, que es el eje del programador: obligan al dueño a saber
// qué busca antes de entrar y dejan la conclusión en la cuarta solapa. Acá la
// conclusión es la primera.

import React from "react";
import { Container, Alert } from "reactstrap";
import { connect } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import NotaDatoOriginal from "../../components/Common/NotaDatoOriginal";
import PageSpinner from "../../components/Common/PageSpinner";

import useStatsData from "./useStatsData";
import BarraFija from "./BarraFija";
import PestanasDetalle from "./PestanasDetalle";

const Stats2 = ({ company_id, syncVersion, abonados, nombre, pie }) => {
  document.title = "Estadísticas | TicketControl Monitor";

  const { cargando, error, cerrados, hoy, vivo, diarios, mensuales, diasConDatos } =
    useStatsData(company_id, syncVersion);
  const capacidad = vivo?.occupancy?.capacity || 0;

  if (!company_id) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center py-5 text-muted">Selecciona un estacionamiento primero</div>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="TicketControl" breadcrumbItem="Estadísticas" />

        {error && <Alert color="danger" className="py-2">{error}</Alert>}

        {cargando && !cerrados.length ? (
          <PageSpinner />
        ) : (
          <>
            {/* La frescura del dato va arriba de todo y fuera de las pestañas
                porque habilita a todas: si la PC dejó de enviar, cada número de
                cualquier pestaña es una foto vieja presentada como el presente. */}
            <BarraFija vivo={vivo} cerrados={cerrados} secciones={[]} />

            {/* Un cliente con pocos días no puede ver una pantalla que le
                promete tendencias. Se le dice qué falta, antes de que entre. */}
            {diasConDatos < 7 && (
              <Alert color="info" className="py-2" style={{ fontSize: 13 }}>
                <span className="material-symbols-rounded me-1" style={{ fontSize: 17, verticalAlign: "middle" }}>
                  hourglass_top
                </span>
                Todavía hay {diasConDatos === 0 ? "pocos" : diasConDatos} día
                {diasConDatos === 1 ? "" : "s"} de historia. Las comparaciones y los patrones aparecen a
                partir de la primera semana.
              </Alert>
            )}

            <PestanasDetalle
              cerrados={cerrados}
              hoy={hoy}
              vivo={vivo}
              diarios={diarios}
              mensuales={mensuales}
              capacidad={capacidad}
              abonados={abonados}
              companyId={company_id}
              nombre={nombre}
            />

          </>
        )}

        {/* El pie lo pone Pages/Estadisticas (el enlace para volver a la vista
            anterior). Va DENTRO del Container a proposito: `.page-content`
            reserva abajo el alto del footer fijo, asi que cualquier cosa
            dibujada como hermana de este div queda tapada por el footer. */}
        <NotaDatoOriginal />
        {pie}
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  company_id: state.companies.currentCompany?.id,
  syncVersion: state.data.syncVersion,
  // Los saldos de abonados no viajan en estadísticas: ya están en el store,
  // cargados por el listener global. Cruzarlos acá da una señal que ninguna
  // pantalla da hoy sin entrar a buscarla.
  abonados: state.data.cc,
  // Para encabezar lo que el dueño se lleva al contador: un papel sin el nombre
  // del estacionamiento no se sabe de quién es.
  nombre: state.companies.currentCompany?.name,
});

export default connect(mapStateToProps)(Stats2);
